// @flow
// eslint-disable-next-line no-unused-vars
import type { Action } from '../interfaces';

import {
  PIN_NAV,
  RECEIVE_VERSIONS,
  TOGGLE_PRIVATE,
  UNPIN_NAV
} from './constants';
import * as defaultValues from './defaultValues';
import type { State } from './interfaces'; // eslint-disable-line no-unused-vars

function reduce<S: State, A: Action<*>>(state: S, action: A): S {
  const result = state || defaultValues.state();

  switch (action.type) {
    case PIN_NAV:
      return {
        ...result,
        navPinned: true
      };

    case RECEIVE_VERSIONS:
      return {
        ...result,
        versions: action.data || defaultValues.versions()
      };

    case TOGGLE_PRIVATE:
      return {
        ...result,
        showPrivateAPI: !result.showPrivateAPI
      };

    case UNPIN_NAV:
      return {
        ...result,
        navPinned: false
      };

    default:
      return result;
  }
}

export {
  PIN_NAV,
  RECEIVE_VERSIONS,
  TOGGLE_PRIVATE,
  UNPIN_NAV
} from './constants';
export type { State } from './interfaces';
export default reduce;



// WEBPACK FOOTER //
// ./src/reducers/app/index.js